import React, { useState } from 'react';
import Icon from '../../../components/atoms/Icon/Icon';
import useBrowserMode from '../../../hooks/useBrowserMode';
import useHomeLinkMode from '../../../hooks/useHomeLinkMode';
import ArticleService from '../../../services/articles';
import SessionService from '../../../services/session';
import Img from "gatsby-image";
import './cardArticleItem.scss';

const CardArticleItem = props => {

  const [isFakeLiked, setisFakeLiked] = useState(false)
  const [isFakeUnLiked, setisFakeUnLiked] = useState(false)
  const likeValue = props.likesInfo ? props.likesInfo.like : ""
  const { isBrowser } = useBrowserMode();
  const { homeLink } = useHomeLinkMode();

  const formatNumber = (num) => {
    if (num > 999999) {
      return parseInt(num / 1000000, 10).toString() + 'M'
    } else if (num > 999) {
      return parseInt(num / 1000, 10).toString() + 'K'
    } else {
      return num
    }
  }

  const handleLike = () => {

    if (!(localStorage.getItem('tokenData') || sessionStorage.getItem('tokenData'))) {
      const payloadLikes = {
        type: "ARTICULO",
        idCMS: props.idArticle,
      }
      ArticleService.setAnomLikes(payloadLikes).then(res => {

        if (res.status === 200) {

          if (localStorage.getItem('LOCAL_LIKES_ARTICLES') !== null) {
            const copyLocalLikes = JSON.parse(localStorage.getItem("LOCAL_LIKES_ARTICLES"))
            localStorage.setItem('LOCAL_LIKES_ARTICLES', JSON.stringify(copyLocalLikes.concat(props.idArticle)))
            props.setlocalLikes(copyLocalLikes.concat(props.idArticle))
            isFakeUnLiked ? setisFakeUnLiked(false) : setisFakeLiked(true)
          } else {
            localStorage.setItem('LOCAL_LIKES_ARTICLES', JSON.stringify([props.idArticle]))
            props.setlocalLikes([props.idArticle])
            isFakeUnLiked ? setisFakeUnLiked(false) : setisFakeLiked(true)
          }

        } else {
          console.log(res)
        }

      }).catch(e => console.log(e))
    } else {
      const payloadc = {
        type: "ARTICULO",
        idCMS: props.idArticle,
      }
      const config = {
        headers: {
          Authorization: SessionService.getIdTokenData(),
        },
      }
      ArticleService.setAuthLikes(payloadc, config).then(res => {

        if (res.status === 200) {

          if (localStorage.getItem('LOCAL_LIKES_ARTICLES') !== null) {
            const copyLocalLikes = JSON.parse(localStorage.getItem("LOCAL_LIKES_ARTICLES"))
            localStorage.setItem('LOCAL_LIKES_ARTICLES', JSON.stringify(copyLocalLikes.concat(props.idArticle)))
            props.setlocalLikes(copyLocalLikes.concat(props.idArticle))
            isFakeUnLiked ? setisFakeUnLiked(false) : setisFakeLiked(true)
          } else {
            localStorage.setItem('LOCAL_LIKES_ARTICLES', JSON.stringify([props.idArticle]))
            props.setlocalLikes([props.idArticle])
            isFakeUnLiked ? setisFakeUnLiked(false) : setisFakeLiked(true)
          }

        } else {
          console.log(res)
        }

      }).catch(e => console.log(e))
    }
  }

  const handleUnLike = () => {

    if (!(localStorage.getItem('tokenData') || sessionStorage.getItem('tokenData'))) {
      const payloadUnlike = {
        type: "ARTICULO",
        idCMS: props.idArticle,
      }

      ArticleService.setAnomUnLikes(payloadUnlike).then(res => {
        if (res.status === 200) {
          const copyLocalLikes = JSON.parse(localStorage.getItem("LOCAL_LIKES_ARTICLES"))
          localStorage.setItem('LOCAL_LIKES_ARTICLES', JSON.stringify(copyLocalLikes.filter(item => item !== props.idArticle)))
          props.setlocalLikes(copyLocalLikes.filter(item => item !== props.idArticle))
          isFakeLiked ? setisFakeLiked(false) : setisFakeUnLiked(true)

        } else {
          console.log(res)
        }
      }).catch(e => console.log(e))
    } else {
      const payload = {
        type: "ARTICULO",
        idCMS: props.idArticle,
      }
      const config = {
        headers: {
          Authorization: SessionService.getIdTokenData(),
        },
      }

      ArticleService.setAuthUnLikes(payload, config).then(res => {
        if (res.status === 200) {
          const copyLocalLikes = JSON.parse(localStorage.getItem("LOCAL_LIKES_ARTICLES"))
          localStorage.setItem('LOCAL_LIKES_ARTICLES', JSON.stringify(copyLocalLikes.filter(item => item !== props.idArticle)))
          props.setlocalLikes(copyLocalLikes.filter(item => item !== props.idArticle))
          isFakeLiked ? setisFakeLiked(false) : setisFakeUnLiked(true)

        } else {
          console.log(res)
        }
      }).catch(e => console.log(e))
    }
  }

  return (
    <>
      {isBrowser &&
        <a href={homeLink + props.articulo.slug} className="f-article-card" onClick={(event) => {
          if (props.onClick) {
            props.onClick(event)
          }
        }}>
          <div className={`f-card-article-header f-card-article-header-${props.articulo.categorias[0].slug}`}>
            <Img className="f-card-article-header-img"
              fluid={props.isMobile ? props.articulo.imagenArticuloPrevisualizacion[1] !== undefined ? props.articulo.imagenArticuloPrevisualizacion[1].fluid : null : props.articulo.imagenArticuloPrevisualizacion[0].fluid}
              alt={props.articulo.imagenArticuloPrevisualizacion[0].description} />
          </div>
          <div className="f-card-article-body">

            <div className="f-likes-container">
              {props.isLocalLiked ?
                <div className="f-icon-heart" onClick={e => { handleUnLike(); e.preventDefault() }}></div>
                :
                <div className="f-icon-heart-gray" onClick={e => { handleLike(); e.preventDefault() }}></div>
              }
              <label className="f-count-likes">{formatNumber(isFakeLiked ? likeValue + 1 : isFakeUnLiked ? likeValue - 1 : likeValue)}</label>
            </div>

            <div className={`f-tag-category f-category-${props.articulo.categorias[0].slug}`}>
              {props.articulo.categorias !== null ? props.articulo.categorias[0].slug : null}
            </div>
            <div className="f-card-article-title-container">
              <label className="f-card-article-title">{props.articulo.titulo}</label>
            </div>
            <div className="f-card-article-description-container">
              <p className="f-card-article-description">{props.articulo.descripcionArticulo}</p>
            </div>
          </div>
          <div className={`f-relational-tag f-relational-tag-${props.articulo.categorias[0].slug}`}>
            {props.articulo.etiquetas[0].nombreDeEtiqueta}
          </div>
          <aside>
            <div className={`f-card-showmore f-btn-article-${props.articulo.categorias[0].slug.toLowerCase()}`}><Icon icon="icon-plus" size="1" tagType="i" /></div>
          </aside>
        </a>
      }
    </>
  )
}

export default CardArticleItem;
